<div class="template-2">
  @if (businessCardLoader) {
    <div class="container">
      <div class="row vh-100 d-flex justify-content-center align-items-center">
        <div class="spinner-border text-secondary my-3 font-weight-bold d-flex align-items-center" role="status"></div>
      </div>
    </div>
  } @else {
    @if (businessCardData.status === 'Inactive') {
      <div class="container">
        <div class="row vh-100 d-flex justify-content-center align-items-center">
          <div class="col-12 d-flex flex-column align-items-center">
            <img src="../../../../assets/images/nirlatLogo.png" alt="logo" />
            <p class="h4 my-2 poppins-extrabold text-center">{{ 'inActiveBusinessCard.value' | translate }}</p>
            <p class="h6 mb-0 text-center">{{ 'activeCardMessage.value' | translate }}</p>
          </div>
        </div>
      </div>
    } @else {
      <div class="container">
        <div class="row block-1 justify-content-center g-1 g-md-2 mb-2">
          <div class="col-lg-8 mb-0 mb-md-3 mt-4 mt-md-2">
            <nav class="navbar navbar-expand-md navbar-light">
              <div class="container-fluid">
                <div class="top-bar d-flex align-items-center justify-content-between">
                  <div class="nav-capsule d-flex gap-3 align-items-center">
                    <img
                      class="img-fluid navbar-btn btn-shadow"
                      [src]="
                        businessCardData.logo
                          ? environment.imageUrl + businessCardData.logo
                          : '../../../../assets/images/user.png'
                      "
                      alt="logo"
                    />
                    <p class="fs-5 poppins-extrabold me-3 mb-0 business-name">
                      {{ businessCardData.company | titlecase }}
                    </p>
                  </div>
                  <button
                    class="navbar-toggler btn-shadow p-0"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span class="mdi mdi-menu"></span>
                  </button>
                </div>
                <div class="collapse navbar-collapse mt-2" id="navbarSupportedContent">
                  <div class="d-flex w-100 justify-content-around align-items-md-center align-items-start">
                    <ul class="navbar-nav navigation-links align-items-center justify-content-around w-100">
                      <li class="nav-item">
                        <a (click)="scroll('projectGallary')" aria-current="true" class="text-black nav-link"
                          >{{ 'projectGallery.value' | translate | titlecase }}
                        </a>
                      </li>
                      <li class="nav-item">
                        <a (click)="scroll('recommendationGallary')" class="text-black nav-link"
                          >{{ 'customerRecommendation.value' | translate | titlecase }}
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="text-black nav-link contact-me"
                          *ngIf="businessCardData.clientPhoneNumber"
                          target="_blank"
                          [href]="'https://api.whatsapp.com/send?phone=' + businessCardData.clientPhoneNumber"
                          >{{ 'contactMe.value' | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
        <div class="row my-3" *ngIf="businessCardData.profileImage">
          <div class="col-12">
            <div class="position-relative">
              <img
                class="img-fluid w-100 cover-image"
                [src]="environment.imageUrl + businessCardData.profileImage"
                alt=""
              />
              <img
                class="profile-image"
                [src]="environment.imageUrl + businessCardData.logo"
                *ngIf="businessCardData.logo"
                alt=""
              />
            </div>
          </div>
        </div>
        <div
          class="row text-center"
          [ngClass]="businessCardData.profileImage && businessCardData.logo ? 'slogan-block' : ''"
        >
          <p class="mb-0 fs-3 poppins-extrabold word-break">{{ businessCardData.company | titlecase }}</p>
          <p class="mb-0 fs-6 poppins-light word-break">{{ businessCardData.slogan }}</p>
          <p class="mb-0 fs-6 poppins-light word-break" [innerHTML]="businessCardData.description"></p>
        </div>
        <div class="row g-1 g-md-2 d-flex mb-4 mt-4 icon-links-container">
          <div
            class="col-12 d-sm-flex d-none flex-wrap"
            [ngClass]="this.linkCount <= 5 ? 'justify-content-center' : 'justify-content-around'"
            dir="ltr"
          >
            <a
              *ngIf="businessCardData.email"
              [href]="'mailto:' + businessCardData.email"
              class="text-white nav-link icon-bg bg-warning ms-1"
              target="_blank"
            >
              <i-feather class="icon-lg text-dark" name="mail"></i-feather>
            </a>
            <a
              *ngIf="businessCardData.wpNumber || businessCardData.clientPhoneNumber"
              [href]="getWhatsAppLink()"
              class="text-white nav-link icon-bg bg-warning ms-1"
              target="_blank"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 448 512">
                <path
                  d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                />
              </svg>
            </a>
            <a
              *ngIf="businessCardData.webUrl"
              [href]="businessCardData.webUrl"
              class="text-white nav-link icon-bg bg-warning ms-1"
              target="_blank"
            >
              <i-feather class="icon-lg text-dark" name="globe"></i-feather>
            </a>
            <a
              *ngIf="businessCardData.fbUrl"
              [href]="businessCardData.fbUrl"
              target="_blank"
              class="text-white nav-link icon-bg bg-warning ms-1"
            >
              <i-feather class="icon-lg text-dark" name="facebook"></i-feather>
            </a>
            <a
              *ngIf="businessCardData.instaUrl"
              [href]="businessCardData.instaUrl"
              target="_blank"
              class="text-white nav-link icon-bg bg-warning ms-1"
            >
              <i-feather class="icon-lg text-dark" name="instagram"></i-feather>
            </a>
            <a
              *ngIf="businessCardData.tiktokUrl"
              [href]="businessCardData.tiktokUrl"
              target="_blank"
              class="text-white nav-link icon-bg bg-warning ms-1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 448 512">
                <path
                  d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"
                />
              </svg>
            </a>
            <a
              *ngIf="businessCardData.youtubeUrl"
              [href]="businessCardData.youtubeUrl"
              target="_blank"
              class="text-white nav-link icon-bg bg-warning ms-1"
            >
              <i-feather class="icon-lg text-dark" name="youtube"></i-feather>
            </a>
          </div>
          <div class="col-12 d-flex d-sm-none justify-content-center mb-2">
            <div class="d-flex flex-wrap justify-content-center links-block-sm gap-3" dir="ltr">
              <a
                *ngIf="businessCardData.email"
                [href]="'mailto:' + businessCardData.email"
                class="text-white nav-link icon-bg bg-warning"
                target="_blank"
                ><i-feather class="icon-md text-dark" name="mail"></i-feather>
              </a>

              <a
                *ngIf="businessCardData.wpNumber || businessCardData.clientPhoneNumber"
                [href]="getWhatsAppLink()"
                class="text-white nav-link icon-bg bg-warning"
                target="_blank"
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 448 512">
                  <path
                    d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                  />
                </svg>
              </a>
              <a
                *ngIf="businessCardData.webUrl"
                [href]="businessCardData.webUrl"
                target="_blank"
                class="text-white nav-link icon-bg bg-warning"
                ><i-feather class="icon-md text-dark" name="globe"></i-feather>
              </a>

              <a
                *ngIf="businessCardData.fbUrl"
                [href]="businessCardData.fbUrl"
                class="text-white nav-link icon-bg bg-warning"
                target="_blank"
                ><i-feather class="icon-md text-dark" name="facebook"></i-feather>
              </a>
              <a
                *ngIf="businessCardData.instaUrl"
                [href]="businessCardData.instaUrl"
                class="text-white nav-link icon-bg bg-warning"
                target="_blank"
                ><i-feather class="icon-md text-dark" name="instagram"></i-feather>
              </a>

              <a
                *ngIf="businessCardData.tiktokUrl"
                [href]="businessCardData.tiktokUrl"
                class="text-white nav-link icon-bg bg-warning"
                target="_blank"
                ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 448 512">
                  <path
                    d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"
                  />
                </svg>
              </a>

              <a
                *ngIf="businessCardData.youtubeUrl"
                [href]="businessCardData.youtubeUrl"
                class="text-white nav-link icon-bg bg-warning"
                target="_blank"
                ><i-feather class="icon-md text-dark" name="youtube"></i-feather>
              </a>
            </div>
          </div>
        </div>
        <div class="g-3 mb-3 mt-1 mt-md-0 block-2" [dir]="businessCardData.youtubeVideoUrl ? 'ltr' : 'rtl'">
          <div class="video-container mt-0 placeholder-glow" *ngIf="businessCardData.youtubeVideoUrl">
            <iframe
              [src]="videoId"
              title="YouTube video player"
              frameborder="0"
              class="border-radius h-100 w-100 video-height"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div class="description-box mt-1 mt-md-0 bg-card border-radius p-3 mb-3 mb-md-0">
            <div
              class="d-flex flex-column border-radius justify-content-evenly align-items-md-start align-items-center justify-content-md-between h-100"
            >
              <h4 class="mb-2 poppins-extrabold p-2 fs-4 slogan-box">
                <!-- {{ 'aboutMe.value' | translate }} -->
                {{ businessCardData.businessTitle }}
              </h4>
              <p class="mb-2 poppins-light p-2 description-text" [innerHTML]="businessCardData.businessDescription"></p>
              <a
                *ngIf="businessCardData.clientPhoneNumber"
                [href]="'https://api.whatsapp.com/send?phone=' + businessCardData.clientPhoneNumber"
                class="btn btn-warning poppins-extrabold w-100 p-2 d-none d-md-flex gap-3 justify-content-center align-items-center"
                dir="ltr"
                target="_blank"
              >
                {{ 'contactMe.value' | translate | titlecase }}
                <i-feather class="icon-lg text-dark" name="message-circle"></i-feather>
              </a>
            </div>
          </div>
        </div>
        <div class="row block-3 g-1 g-md-2 mb-5" id="projectGallary" *ngIf="businessCardData.workGallary.length">
          <div class="col-12 text-md-center text-start">
            <p class="fs-md-4 fs-5 poppins-extrabold">{{ 'projectGallery.value' | translate | titlecase }}</p>
          </div>
          <div class="col-12 workGallaryCarosule">
            <app-slide-generator
              [config]="workGallarySlideConfig"
              [isLoading]="isLoading"
              [imagePaths]="businessCardData.workGallary"
            ></app-slide-generator>
          </div>
        </div>
        <div
          class="row block-4 mb-md-5 mb-5"
          id="recommendationGallary"
          *ngIf="businessCardData.recommendationGallary.length"
        >
          <div class="col-12 text-md-center text-start">
            <p class="fs-md-4 fs-5 poppins-extrabold">{{ 'customerRecommendation.value' | translate | titlecase }}</p>
          </div>
          <div class="col-12 recommendationGallaryCarasoul">
            <app-slide-generator
              [config]="recommendationGallarySlideConfig"
              [imagePaths]="businessCardData.recommendationGallary"
              [isLoading]="isLoading"
            >
            </app-slide-generator>
          </div>
        </div>
        <div class="block-5 d-flex w-100 justify-content-center gap-5 align-items-center mt-3">
          <a
            *ngIf="businessCardData.clientPhoneNumber"
            [href]="'https://api.whatsapp.com/send?phone=' + businessCardData.clientPhoneNumber"
            class="btn-sticky w-50 btn d-flex gap-2 justify-content-center align-items-center btn-warning poppins-extrabold fs-6 btn-lg p-2"
            dir="ltr"
            target="_blank"
          >
            {{ 'contactMe.value' | translate | titlecase }}
            <i-feather class="icon-lg text-dark" name="message-circle"></i-feather>
          </a>
        </div>
        <div class="d-flex justify-content-between mt-4 gap-5 mb-2">
          <section class="d-flex fs-7" dir="ltr">
            Power By <img src="../../../../assets/images/logo/logo.png" class="img-fluid footer-img" alt="" />
          </section>
          <section class="d-flex fs-7">Copyright &copy; All rights Reserved</section>
        </div>
      </div>
    }
  }
</div>
